var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCrab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.007,
    x2: 154.438,
    xlinkHref: "#lg1",
    y1: 177.617,
    y2: 259.705
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.753,
    x2: 77.089,
    xlinkHref: "#lg1",
    y1: 358.231,
    y2: 386.941
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.888,
    x2: 45.149,
    xlinkHref: "#lg1",
    y1: 265.811,
    y2: 311.27
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.417,
    x2: 113.86,
    xlinkHref: "#lg1",
    y1: 409.215,
    y2: 411.437
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe860a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6914,
    stopColor: "#fc482b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(.707 .707 -.707 .707 545.214 1339.241)",
    gradientUnits: "userSpaceOnUse",
    x1: -1173.393,
    x2: -1144.278,
    xlinkHref: "#lg2",
    y1: -499.232,
    y2: -478.161
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(.707 .707 -.707 .707 545.214 1339.241)",
    gradientUnits: "userSpaceOnUse",
    x1: -1168.782,
    x2: -1126.912,
    xlinkHref: "#lg2",
    y1: -567.416,
    y2: -516.574
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(.707 .707 -.707 .707 545.214 1339.241)",
    gradientUnits: "userSpaceOnUse",
    x1: -1190.827,
    x2: -1122.64,
    xlinkHref: "#lg2",
    y1: -590.623,
    y2: -541.277
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.505,
    x2: 455.321,
    xlinkHref: "#lg1",
    y1: 192.767,
    y2: 254.148
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 461.631,
    x2: 432.472,
    xlinkHref: "#lg1",
    y1: 361.086,
    y2: 388.002
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 458.837,
    x2: 425.985,
    xlinkHref: "#lg1",
    y1: 266.163,
    y2: 341.823
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.674,
    x2: 379.138,
    xlinkHref: "#lg1",
    y1: 410.277,
    y2: 412.615
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(-.707 .707 .707 .707 -3547.572 1339.241)",
    gradientUnits: "userSpaceOnUse",
    x1: -3657.005,
    x2: -3627.89,
    xlinkHref: "#lg2",
    y1: 1984.38,
    y2: 2005.451
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(-.707 .707 .707 .707 -3547.572 1339.241)",
    gradientUnits: "userSpaceOnUse",
    x1: -3652.394,
    x2: -3610.524,
    xlinkHref: "#lg2",
    y1: 1916.196,
    y2: 1967.038
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(-.707 .707 .707 .707 -3547.572 1339.241)",
    gradientUnits: "userSpaceOnUse",
    x1: -3674.44,
    x2: -3606.252,
    xlinkHref: "#lg2",
    y1: 1892.989,
    y2: 1942.335
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.065,
    x2: 271.748,
    xlinkHref: "#lg2",
    y1: 163.514,
    y2: 238.88
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.207,
    x2: 364.55,
    xlinkHref: "#lg2",
    y1: 239.394,
    y2: 410.12
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 269.171,
    x2: 395.827,
    xlinkHref: "#lg3",
    y1: 273.352,
    y2: 404.926
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.23,
    x2: 202.23,
    xlinkHref: "#lg3",
    y1: 246.758,
    y2: 215.425
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.691,
    x2: 111.358,
    xlinkHref: "#lg3",
    y1: 268.239,
    y2: 265.906
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.731,
    x2: 307.064,
    xlinkHref: "#lg3",
    y1: 277.493,
    y2: 218.493
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.414,
    x2: 212.58,
    xlinkHref: "#lg4",
    y1: 142.485,
    y2: 153.651
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.965,
    x2: 298.694,
    xlinkHref: "#lg4",
    y1: 143.066,
    y2: 154.794
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m115.664 313.285c-2.88-.601-5.617-2.019-7.851-4.253l-43.82-43.811c-32.407-32.416-32.407-85.154 0-117.57l11.834-11.834c6.137-6.128 16.078-6.128 22.206 0 6.137 6.137 6.137 16.078 0 22.206l-11.834 11.834c-20.169 20.169-20.169 52.989 0 73.158l27.069 27.069c-.61 3.517-.924 7.214-.924 11.098 0 11.126 1.14 21.865 3.32 32.103z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.28 356.162-28.486 5.141c-28.074 5.06-46.789 32.012-41.729 60.086l2.97 16.464c1.534 8.541-4.136 16.706-12.669 18.24-.942.17-1.875.251-2.799.251-7.456 0-14.068-5.32-15.441-12.911l-2.97-16.473c-8.129-45.112 21.955-88.429 67.057-96.566l20.941-3.777c3.293 10.497 7.707 20.394 13.126 29.545z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.164 332.565-52.765-9.519c-21.856-3.939-40.859-16.15-53.527-34.39-12.669-18.24-17.469-40.321-13.53-62.176l2.97-16.464c1.543-8.532 9.699-14.203 18.24-12.669 8.532 1.543 14.203 9.708 12.66 18.24l-2.97 16.473c-2.449 13.593.538 27.329 8.425 38.679 7.878 11.35 19.712 18.949 33.304 21.407l39.405 7.106c1.346 11.691 3.992 22.834 7.788 33.313z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.597 453.877c3.993 7.698.996 17.181-6.702 21.174-2.306 1.202-4.782 1.768-7.223 1.768-5.67 0-11.152-3.086-13.943-8.47l-7.716-14.849c-10.237-19.703-12.175-42.214-5.482-63.388 5.24-16.562 15.27-30.747 28.827-41.038 4.872 9.466 10.766 18.231 17.531 26.181-7.662 6.289-13.359 14.66-16.419 24.332-4.172 13.171-2.952 27.176 3.409 39.441z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m98.873 191.76c-10.158 10.158-29.754 7.031-43.77-6.984-14.015-14.015-17.142-33.612-6.984-43.77s60.912 40.596 50.754 50.754z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 118.203,
    cy: 129.975,
    fill: "url(#SVGID_6_)",
    r: 67.662
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.405 177.867c3.016 3.011 6.87 5.063 11.031 5.99 49.161 10.949 33.747-27.884 55.64-36.803 22.839-9.305 3.807-16.495 15.649-41.026 6.719-13.919 25.828-18.442 41.103-19.751 7.367-.631 11.317-8.978 7.236-15.144-3.61-5.454-7.918-10.583-12.923-15.26-32.888-30.731-84.685-30.173-116.942 1.218-33.947 33.036-34.228 87.341-.84 120.729.015.015.03.031.046.047z",
    fill: "url(#SVGID_7_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m446.006 265.221-43.82 43.811c-2.234 2.234-4.97 3.652-7.851 4.253 2.18-10.237 3.32-20.977 3.32-32.102 0-3.885-.314-7.581-.924-11.098l27.069-27.069c20.169-20.169 20.169-52.989 0-73.158l-11.834-11.834c-6.137-6.128-6.137-16.069 0-22.206 6.128-6.128 16.069-6.128 22.206 0l11.834 11.834c32.408 32.415 32.408 85.153 0 117.569z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.844 426.961-2.97 16.473c-1.373 7.59-7.985 12.911-15.441 12.911-.924 0-1.857-.081-2.799-.251-8.532-1.534-14.203-9.699-12.669-18.24l2.97-16.464c5.06-28.074-13.655-55.026-41.729-60.086l-28.486-5.141c5.419-9.152 9.833-19.048 13.126-29.545l20.941 3.777c45.103 8.137 75.186 51.454 67.057 96.566z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m495.129 288.656c-12.669 18.24-31.671 30.451-53.527 34.39l-52.765 9.519c3.795-10.479 6.442-21.623 7.788-33.313l39.405-7.106c13.593-2.458 25.427-10.058 33.304-21.407 7.886-11.35 10.874-25.086 8.425-38.679l-2.97-16.473c-1.543-8.532 4.127-16.697 12.66-18.24 8.541-1.534 16.697 4.136 18.24 12.669l2.97 16.464c3.938 21.856-.862 43.936-13.53 62.176z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.986 453.5-7.716 14.849c-2.79 5.383-8.272 8.47-13.943 8.47-2.44 0-4.917-.565-7.223-1.768-7.698-3.993-10.695-13.476-6.702-21.174l7.716-14.849c6.361-12.265 7.581-26.27 3.409-39.441-3.059-9.672-8.757-18.043-16.419-24.332 6.765-7.949 12.66-16.715 17.531-26.181 13.557 10.291 23.588 24.476 28.827 41.038 6.695 21.174 4.757 43.685-5.48 63.388z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m411.127 191.76c10.158 10.158 29.754 7.031 43.77-6.984 14.015-14.015 17.142-33.612 6.984-43.77s-60.912 40.596-50.754 50.754z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 391.797,
    cy: 129.975,
    fill: "url(#SVGID_13_)",
    r: 67.662
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.595 177.867c-3.016 3.011-6.87 5.063-11.031 5.99-49.161 10.949-33.747-27.884-55.64-36.803-22.839-9.305-3.807-16.495-15.649-41.026-6.719-13.919-25.828-18.442-41.103-19.751-7.367-.631-11.317-8.978-7.236-15.144 3.61-5.454 7.918-10.583 12.923-15.26 32.887-30.731 84.684-30.173 116.942 1.218 33.947 33.036 34.228 87.341.84 120.729-.015.015-.03.031-.046.047z",
    fill: "url(#SVGID_14_)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255 145.414c-50.817 0-90.618 26.874-90.618 63.334s90.618 35.397 90.618 35.397 90.618 1.062 90.618-35.397-39.801-63.334-90.618-63.334z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255 442.85c-93.276 0-166.331-70.822-166.331-166.904s166.331-93.283 166.331-93.283 166.331-2.798 166.331 93.283-73.055 166.904-166.331 166.904z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.331 275.946c0-96.081-166.331-93.283-166.331-93.283v260.187c93.276 0 166.331-70.823 166.331-166.904z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255 206.651c-8.514 0-15.415 6.902-15.415 15.415v40.055c0 8.514 6.902 15.415 15.415 15.415 8.514 0 15.415-6.902 15.415-15.415v-40.055c0-8.513-6.901-15.415-15.415-15.415z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.354 271.329-28.323-28.323c-6.02-6.02-15.78-6.02-21.8 0s-6.02 15.78 0 21.8l28.323 28.323c6.02 6.02 15.78 6.02 21.8 0s6.021-15.78 0-21.8z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.769 243.006c-6.02-6.02-15.78-6.02-21.8 0l-28.323 28.323c-6.02 6.02-6.02 15.78 0 21.8 6.02 6.02 15.78 6.02 21.8 0l28.323-28.323c6.02-6.02 6.02-15.78 0-21.8z",
    fill: "url(#SVGID_20_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 212.515,
    cy: 153.585,
    fill: "url(#SVGID_21_)",
    r: 17.858
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.485,
    cy: 153.585,
    fill: "url(#SVGID_22_)",
    r: 17.858
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrab);
export default __webpack_public_path__ + "static/media/icon-crab.167128cf810e735e66083cbef7e779f3.svg";
export { ForwardRef as ReactComponent };